module.exports = __webpack_public_path__ + "img/sign@2x-100.ef85319a.jpg";